import { FC } from "react";
import { Heading } from "../Typography/Heading";
import "./NotificationBar.css";

export interface NotificationCounterProps {
  /** Number of unread notifications */
  count: number;
  /** Optional class name */
  className?: string;
}

/**
 * NotificationCounter — A compact 16×16 badge displaying unread notification count.
 * Renders nothing when count is 0.
 */
export const NotificationCounter: FC<NotificationCounterProps> = ({
  count,
  className,
}) => {
  if (count <= 0) return null;

  const displayCount = count > 99 ? "99+" : String(count);

  return (
    <span
      className={`notification-counter${className ? ` ${className}` : ""}`}
      aria-label={`${count} unread notifications`}
    >
      <Heading level={6} className="notification-counter__text">
        {displayCount}
      </Heading>
    </span>
  );
};
